import React, { useEffect, useState } from 'react';
import { sitesService, siteColour } from '../../_services/sites.service';
import useSites from './useSites';
import './multiLocation.css';

/** "Also visits <site>" on the client card. Empty in 'separate' mode or for single-site salons. */
export default function AlsoVisitsChip({ clientUserId }) {
    const { multi } = useSites();
    const [sites, setSites] = useState([]);
    const [notes, setNotes] = useState([]);
    useEffect(() => {
        if (!multi || !clientUserId) return;
        sitesService.clientAlsoVisits(clientUserId).then(r => setSites((r && r.sites) || [])).catch(() => setSites([]));
        sitesService.clientNotes(clientUserId).then(r => setNotes((r && r.notes) || [])).catch(() => setNotes([]));
    }, [multi, clientUserId]);
    if (!multi || (!sites.length && !notes.length)) return null;
    return (
        <div className="ml-chip-row" style={{ marginTop: 4 }}>
            {sites.map(s => <span key={String(s.salonId)} className="ml-chip" title={`${s.visits} visit${s.visits === 1 ? '' : 's'}`}><span className="ml-dot" style={{ background: siteColour(s.salonId) }} />Also visits {s.salonName}</span>)}
            {notes.map((n, i) => <span key={i} className="ml-chip" title={n.note}><span className="ml-dot" style={{ background: siteColour(n.salonId) }} />Note at {n.salonName}</span>)}
        </div>
    );
}
